import React, { useState, useMemo } from 'react';
import styles from './PersonalDetails.module.css';
import countryList from 'react-select-country-list';
import Select from 'react-select';
import DoneButton from '../../components/Done Button/DoneButton';
import LoginLeftSide from '../../components/LoginLeftSide/LoginLeftSide';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const PersonalDetails = () => {
  const [name, setName] = useState('');
  const [phoneNumber, setNum] = useState('');
  const [addressLine1, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [province, setProvince] = useState('');
  const [countryName, setCountry] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const navigateTo = useNavigate();
  const countryOpt = useMemo(() => countryList().getData(), [])

  const urlObject = new URL(window.location.href);
  const pathname = urlObject.pathname;
  const baseURL = process.env.NODE_ENV === 'production' ? '/api/rest/account-setup/' : 'http://localhost:8000/rest/account-setup/';

  const setupPath = pathname.substring(pathname.indexOf('/onboarding/') + '/onboarding/'.length);
  const queryParams = urlObject.search;
  const queryURL = baseURL + setupPath + queryParams;

  const clearFields = () => {
    setName('');
    setNum('');
    setAddress('');
    setCity('');
    setProvince('');
    setCountry('');
    setPostalCode('');
    setSubmitting(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const country = countryName.label;

    setSubmitting(true);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: queryURL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({ name, phoneNumber, addressLine1, country, postalCode, city, province })
    };

    axios.request(config)
      .then((response) => {
        alert("Profile updated successfully.");
        navigateTo("/");
        clearFields();
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        alert("Sorry, an error has occurred. Please try again");
        console.log(error);
      })
      .finally(() => setSubmitting(false));

  };

  return (
    <div className={styles.loginContainer}>
      <LoginLeftSide />
      <div className={styles.rightSide}>
        <div className={styles.formcontainer}>
          <div className={styles.title}>Set up new account</div>
          <form onSubmit={handleSubmit}>
            <div className={styles.column1}>
              <label> Name: </label> <br />
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className={styles.fieldinputs}
              />
            </div>

            <div className={styles.column1}>
              <label> Phone Number: </label> <br />
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setNum(e.target.value)}
                required
                className={styles.fieldinputs}
              />
            </div>

            <br />
            <label> Address Line 1: </label> <br />
            <input
              type="text"
              value={addressLine1}
              onChange={(e) => setAddress(e.target.value)}
              required
              className={styles.addrinputs}
            />
            <br />

            <div className={styles.column1}>
              <label> City: </label> <br />
              <input
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
                className={styles.fieldinputs}
              />
            </div>

            <div className={styles.column1}>
              <label> Province: </label> <br />
              <input
                type="text"
                value={province}
                onChange={(e) => setProvince(e.target.value)}
                required
                className={styles.fieldinputs}
              />
            </div>

            <br />
            <div className={styles.column2}>
              <label> Country: </label> <br />
              <Select options={countryOpt}
                value={countryName}
                onChange={(e) => setCountry(e)}
                required
                className={styles.countryinput}
              />
            </div>

            <div className={styles.column2}>
              <label> Postal Code: </label> <br />
              <input
                type="text"
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
                required
                className={styles.fieldinputs}
              />
            </div> <br />

            <br />
            <DoneButton />

          </form>
        </div>
      </div>
    </div>

  );
};

export default PersonalDetails;